export default __webpack_public_path__ + "static/media/CormorantGaramondMediumItalic.c970f02f.woff";